<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="课程名"
                      v-model="listQuery.name">
            </el-input>
            <!--                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
            <!--                          placeholder="用户ID"-->
            <!--                          v-model="listQuery.userId">-->
            <!--                </el-input>-->
            <!--                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
            <!--                          placeholder="讲堂ID"-->
            <!--                          v-model="listQuery.courseId">-->
            <!--                </el-input>-->
            <!--                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
            <!--                          placeholder=""-->
            <!--                          v-model="listQuery.cardId">-->
            <!--                </el-input>-->
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="听课人姓名"
                      v-model="listQuery.userName">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="听课人手机"
                      v-model="listQuery.phone">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="备注"
                      v-model="listQuery.remark">
            </el-input>
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.status"
                       placeholder="状态">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <!--            <el-date-picker-->
            <!--                    class="filter-item input"-->
            <!--                    v-model="listQuery.times"-->
            <!--                    type="datetimerange"-->
            <!--                    range-separator="至"-->
            <!--                    start-placeholder="时间开始日期"-->
            <!--                    end-placeholder="时间结束日期">-->
            <!--            </el-date-picker>-->

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button :loading="activeLoading" class="filter-item" style="margin-left: 10px;" @click="activeSign"
                           type="primary"
                           v-if="canUpdate" icon="el-icon-edit">激活
                </el-button>
                <!--                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
                <!--                           @click="handleDownload">导出-->
                <!--                </el-button>-->
            </div>
        </div>

        <el-table @selection-change="handleSelectionChange" :key='tableKey' :data="list" v-loading="listLoading" border
                  fit highlight-current-row
                  style="width: 100%;min-height:1000px;">
            <el-table-column align="center" type="selection" label="选择">
                <!--                <template slot-scope="scope">-->
                <!--                    <span>{{scope.$index}}</span>-->
                <!--                </template>-->
            </el-table-column>
            <el-table-column align="center" label="课程名">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <!--            <el-table-column align="center" label="用户ID">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <span>{{scope.row.userId}}</span>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column align="center" label="讲堂ID">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <span>{{scope.row.courseId}}</span>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column align="center" label="">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <span>{{scope.row.cardId}}</span>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <el-table-column align="center" label="听课人姓名">
                <template slot-scope="scope">
                    <span>{{scope.row.userName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="听课人手机">
                <template slot-scope="scope">
                    <span>{{scope.row.phone}}</span>
                </template>
            </el-table-column>
            <!--            <el-table-column align="center" label="备注">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <span>{{scope.row.remark}}</span>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                                                <span>

                         <el-tag :type="tagTypes[scope.row.status]">     {{statusOptions[scope.row.status]}}</el-tag>

                        </span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="激活">
                <template slot-scope="scope">
                    <span>{{scope.row.active?'激活':'未激活'}}</span>
                </template>
            </el-table-column>


            <el-table-column align="center" label="时间">
                <template slot-scope="scope">
                    <span>{{parseTime(scope.row.time)}}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <!--                    <el-button type="primary" v-if="scope.row.active" size="mini" @click="handleUpdate(scope)">取消激活</el-button>-->
                    <!--                    <el-button type="primary" v-if="!scope.row.active" size="mini" @click="handleUpdate(scope)">点击激活</el-button>-->
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <!--                <el-form-item label="课程名" prop="name">-->
                <!--                    <el-input v-model="temp.name"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="用户ID" prop="userId">-->
                <!--                    <el-input v-model="temp.userId"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="讲堂ID" prop="courseId">-->
                <!--                    <el-input v-model="temp.courseId"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="" prop="cardId">-->
                <!--                    <el-input v-model="temp.cardId"></el-input>-->
                <!--                </el-form-item>-->
                <el-form-item label="听课人姓名" prop="userName">
                    <el-input v-model="temp.userName"></el-input>
                </el-form-item>
                <el-form-item label="听课人手机" prop="phone">
                    <el-input v-model="temp.phone"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="temp.remark"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select class="filter-item" v-model="temp.status" placeholder="状态">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否激活" prop="status">
                    <el-switch
                            v-model="temp.active"
                            active-text=""
                            inactive-text="">
                    </el-switch>
                </el-form-item>


                <el-form-item label="时间" prop="date">
                    <el-date-picker v-model="temp.time" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="时间">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, save, update, remove} from '@/api/sign'
    import waves from '@/directive/waves' // 水波纹指令
    import {parseTime} from '@/utils'


    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'
    import {active} from "../../../api/sign";

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                multipleSelection: [],
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                activeLoading: false,
                time: null
                ,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'id desc'
                    ,
                    name: null
                    ,
                    userId: null
                    ,
                    courseId: null
                    ,
                    cardId: null
                    ,
                    userName: null
                    ,
                    phone: null
                    ,
                    remark: null
                    ,
                    time: null,
                    times: null
                    ,
                    status: null
                },
                statusOptions: ["预报名", "已确认", "已签到"],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp:
                    {
                        id: null,
                        name: null,
                        userId: null,
                        courseId: null,
                        cardId: null,
                        status: null,
                        userName: null,
                        phone: null,
                        remark: null,
                        time: null,
                        active: null
                    }
                ,
                dialogFormVisible: false,
                dialogStatus:
                    '',
                textMap:
                    {
                        update: '修改',
                        create:
                            '新增'
                    }
                ,
                rules:
                    {
                        name: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        userId: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        courseId: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        cardId: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        status: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'blur'
                            }
                        ]
                        ,
                        userName: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        phone: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        remark: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        time: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key:
                            ''
                    }
            }
        },
        created() {
            this.getList()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'sign:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'sign:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'sign:update')
            },
            canList() {
                return hasAuth(this.perms, 'sign:list')
            }
        },
        methods: {
            activeSign() {
                this.activeLoading = true
                let signIds = this.multipleSelection.map(item => item.id)
                // signIds = [4, 3]
                active(signIds).then(res => {
                    this.getList()
                    this.$notify({
                        title: '成功',
                        message: '激活成功',
                        type: 'success',
                        duration: 2000
                    })
                }).finally(e=>{
                    this.activeLoading = false
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            parseTime(time) {
                return parseTime(time, '{y}-{m}-{d}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片

            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
            },
            resetTemp(row) {

                this.temp = {}
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.resetTemp()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.id]
                const ids = [this.list[this.index].id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.index = scope.$index
                this.beforeFormShow(scope.row)
                this.dialogStatus = 'update'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].clearValidate()
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                this.list.splice(this.index, 1, this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = [
                        '序号'
                        ,
                        '课程名'
                        ,
                        '用户ID'
                        ,
                        '讲堂ID'
                        ,
                        ''
                        ,
                        '听课人姓名'
                        ,
                        '听课人手机'
                        ,
                        '备注'
                        ,
                        '状态'
                        ,
                        '时间'
                    ]
                    const filterVal = ['id'
                        , 'name'
                        , 'userId'
                        , 'courseId'
                        , 'cardId'
                        , 'userName'
                        , 'phone'
                        , 'remark'
                        ,
                        'status'
                        ,
                        'time'
                    ]
                    const data = this.formatJson(filterVal, this.list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: 'table-list'
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                        return v[j]
                    }
                ))
            },
        }
    }
</script>
